import { useSelector } from 'react-redux';
import { validationSchemaContact } from './validationSchema';
import { Form, Formik } from 'formik';
import { CheckBox, TextArea, TextBox } from '../../shared/controls/form';
import { getActiveOwners, getGenericMasterFilteredListByKey } from '../../redux/selector';
import SelectBox from '../../shared/controls/form/selectBox';
import PaginatedDropdown from '../../shared/component/PaginatedDropdown';
import apiServices from '../../services/service';

const ContactForm = ({
  formData,
  handleSubmit,
  selectedOptions,
  handleChange,
  handleChangeForm,
  errormsg,
  handleChangeCheckbox,
}) => {
  const leadSourceDropdown = useSelector(getGenericMasterFilteredListByKey('LeadSource'));
  const salutation = useSelector(getGenericMasterFilteredListByKey('Salutation'));
  const contactPersonRole = useSelector(getGenericMasterFilteredListByKey('ContactPersonRole'));
  const owner = useSelector(getActiveOwners);
  const {
    options: accounts,
    isLoading: isAccountLoading,
    handleSearch: handleAccountSearch,
    handleScroll: handleAccountScroll,
  } = PaginatedDropdown({
    fetchFn: apiServices.getAccountsDropdown, // Replace with actual API
    responseKey: 'accountList',
  });

  return (
    <Formik
      initialValues={formData}
      onSubmit={(values) => handleSubmit(values)}
      validationSchema={validationSchemaContact}
    >
      <Form>
        <div className="collapse_card">
          <div className={formData?.type === 'view' ? 'addleadcard-view' : 'addleadcard'}>
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12">
                <div className="infoBox">
                  <div className="addlead-header pd_card">
                    <label htmlFor="" className="flex-div align-items-center">
                      <img className="me-2" src="../assets/images/companyInfo.svg" alt="" />
                      Contact Information
                    </label>
                  </div>
                  <div className="leadcontent pd_card leadDetailInfo contactPd">
                    <div className="row gx-4">
                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container">
                          <SelectBox
                            label={'Salutation'}
                            name={'salutationId'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.salutation || '--'
                                : formData?.salutation || 'Select Salutation'
                            }
                            // isRequired={true}
                            disabled={formData?.type === 'view'}
                            selectedOptions={selectedOptions.salutationId}
                            handleSelect={handleChange}
                            options={salutation}
                            optionKeys={['id', 'displayName']}
                            errormsg={errormsg?.salutationId}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container">
                          <TextBox
                            label={'First Name'}
                            name={'firstName'}
                            disabled={formData?.type === 'view'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter First Name'}
                            value={formData?.firstName}
                            handleChange={handleChangeForm}
                            maxLength={250}
                            errormsg={errormsg?.firstName}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container">
                          <TextBox
                            label={'Middle Name'}
                            name={'middleName'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Middle Name'}
                            value={formData?.middleName}
                            disabled={formData?.type === 'view'}
                            handleChange={handleChangeForm}
                            maxLength={250}
                            errormsg={errormsg?.middleName}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container">
                          <TextBox
                            isRequired={true}
                            label={'Last Name'}
                            name={'lastName'}
                            disabled={formData?.type === 'view'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Last Name'}
                            value={formData?.lastName}
                            handleChange={handleChangeForm}
                            maxLength={250}
                            errormsg={errormsg?.lastName}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container">
                          <TextBox
                            isRequired={false}
                            label={'Title'}
                            name={'title'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Title'}
                            value={formData?.title}
                            disabled={formData?.type === 'view'}
                            handleChange={handleChangeForm}
                            maxLength={250}
                            errormsg={errormsg?.title}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container LinkDes">
                          <TextBox
                            // isRequired={true}
                            label={'Email'}
                            name={'email'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Email'}
                            value={formData?.email}
                            disabled={formData?.type === 'view'}
                            handleChange={handleChangeForm}
                            maxLength={250}
                            errormsg={errormsg?.email}
                            fieldType="email"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container LinkDes">
                          <TextBox
                            label={'Secondary Email'}
                            name={'secondaryEmail'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Secondary Email'}
                            value={formData?.secondaryEmail}
                            disabled={formData?.type === 'view'}
                            handleChange={handleChangeForm}
                            maxLength={250}
                            errormsg={errormsg?.secondaryEmail}
                            fieldType="email"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container">
                          <TextBox
                            label={'Department'}
                            name={'department'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Department'}
                            disabled={formData?.type === 'view'}
                            value={formData?.department}
                            handleChange={handleChangeForm}
                            maxLength={250}
                            errormsg={errormsg?.department}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container">
                          <SelectBox
                            label={'Account Name'}
                            name={'accountId'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.account || '--'
                                : formData?.account || 'Select Account Name'
                            }
                            // isRequired={true}
                            disabled={formData?.type === 'view'}
                            selectedOptions={selectedOptions.accountId}
                            handleSelect={handleChange}
                            options={accounts}
                            optionKeys={['id', 'name']}
                            errormsg={errormsg?.accountId}
                            isLoading={isAccountLoading}
                            onScrollToBottom={handleAccountScroll}
                            onSearch={handleAccountSearch}
                            fieldType="accountId"
                            fieldId={formData?.accountId}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container">
                          <TextBox
                            label={'Phone'}
                            name={'phone'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Phone'}
                            value={formData?.phone}
                            disabled={formData?.type === 'view'}
                            handleChange={handleChangeForm}
                            maxLength={20}
                            errormsg={errormsg?.phone}
                            fieldType="phone"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container">
                          <TextBox
                            label={'Mobile'}
                            name={'mobile'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Mobile'}
                            value={formData?.mobile}
                            disabled={formData?.type === 'view'}
                            handleChange={handleChangeForm}
                            maxLength={20}
                            errormsg={errormsg?.mobile}
                            fieldType="phone"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container">
                          <TextBox
                            label={'Reporting To'}
                            name={'reportingTo'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Reporting To'}
                            value={formData?.reportingTo}
                            disabled={formData?.type === 'view'}
                            handleChange={handleChangeForm}
                            maxLength={250}
                            errormsg={errormsg?.reportingTo}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container">
                          <TextBox
                            label={'Assistant'}
                            name={'assistant'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Assistant'}
                            value={formData?.assistant}
                            handleChange={handleChangeForm}
                            disabled={formData?.type === 'view'}
                            maxLength={250}
                            errormsg={errormsg?.assistant}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container">
                          <TextBox
                            label={'Assistant Phone'}
                            name={'assistantPhone'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Assistant Phone'}
                            disabled={formData?.type === 'view'}
                            value={formData?.assistantPhone}
                            handleChange={handleChangeForm}
                            maxLength={20}
                            errormsg={errormsg?.assistantPhone}
                            fieldType="phone"
                          />
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container">
                          <SelectBox
                            label={'Contact Person Role'}
                            name={'contactPersonRoleId'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.contactPersonRole || '--'
                                : formData?.contactPersonRole || 'Select Contact Person Role'
                            }
                            // isRequired={true}
                            disabled={formData?.type === 'view'}
                            selectedOptions={selectedOptions.contactPersonRoleId}
                            handleSelect={handleChange}
                            options={contactPersonRole}
                            optionKeys={['id', 'displayName']}
                            errormsg={errormsg?.contactPersonRoleId}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container">
                          <CheckBox
                            label={'Email Opt Out'}
                            name={'emailOptOut'}
                            checked={formData?.emailOptOut}
                            handleChange={handleChangeCheckbox}
                            disabled={formData?.type === 'view'}
                            // maxLength={250}
                            // errormsg={errormsg?.emailOptOut}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12">
                <div className="infoBox">
                  <div className="addlead-header pd_card">
                    <label htmlFor="" className="flex-div align-items-center">
                      {' '}
                      <img className="me-2" src="../assets/images/companyInfo.svg" alt="" />
                      General Information
                    </label>
                  </div>
                  <div className="leadcontent leadDetailInfo contactPd">
                    <div className="row gx-4">
                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container">
                          <SelectBox
                            label={'Contact Owner'}
                            name={'ownerId'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.owner || '--'
                                : formData?.owner || 'Select Contact Owner'
                            }
                            // isRequired={true}
                            disabled={formData?.type === 'view'}
                            selectedOptions={selectedOptions.ownerId}
                            handleSelect={handleChange}
                            options={owner}
                            optionKeys={['userId', 'userName']}
                            errormsg={errormsg?.ownerId}
                            nameFormatter={true}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="input-container">
                          <SelectBox
                            label={'Lead Source'}
                            name={'leadSourceId'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.leadSource || '--'
                                : formData?.leadSource || 'Select Lead Source'
                            }
                            isRequired={true}
                            disabled={formData?.type === 'view'}
                            selectedOptions={selectedOptions.leadSourceId}
                            handleSelect={handleChange}
                            options={leadSourceDropdown}
                            optionKeys={['id', 'displayName']}
                            errormsg={errormsg?.leadSourceId}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col--md-12">
                <div className="row gx-3">
                  <div className="col-12 col-sm-12 col-md-6 ">
                    <div className="infoBox">
                      <div className="addlead-header pd_card">
                        <label htmlFor="" className="flex-div align-items-center">
                          <img className="me-2" src="../assets/images/socialIcon.svg" alt="" />
                          Social Media
                        </label>
                      </div>
                      <div className="leadcontent pd_card leadDetailInfo contactHt1">
                        <>
                          <div className="row">
                            <div className="col-12 col-sm-12 col-md-12">
                              <div className="input-container LinkDes">
                                <TextBox
                                  label={'LinkedIn'}
                                  name={'linkedin'}
                                  placeholder={formData?.type === 'view' ? '--' : 'Enter LinkedIn'}
                                  value={formData?.linkedin}
                                  handleChange={handleChangeForm}
                                  disabled={formData?.type === 'view'}
                                  maxLength={250}
                                  errormsg={errormsg?.linkedin}
                                  fieldType="link"
                                />
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 col-md-12">
                              <div className="input-container LinkDes">
                                <TextBox
                                  label={'Twitter'}
                                  name={'twitter'}
                                  placeholder={formData?.type === 'view' ? '--' : 'Enter Twitter'}
                                  value={formData?.twitter}
                                  handleChange={handleChangeForm}
                                  disabled={formData?.type === 'view'}
                                  maxLength={250}
                                  errormsg={errormsg?.twitter}
                                  fieldType="link"
                                />
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12">
                              <div className="input-container LinkDes">
                                <TextBox
                                  label={'Facebook'}
                                  name={'facebook'}
                                  placeholder={formData?.type === 'view' ? '--' : 'Enter Facebook'}
                                  value={formData?.facebook}
                                  handleChange={handleChangeForm}
                                  disabled={formData?.type === 'view'}
                                  maxLength={250}
                                  errormsg={errormsg?.facebook}
                                  fieldType="link"
                                />
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 col-md-12">
                              <div className="input-container LinkDes">
                                <TextBox
                                  label={'Skype ID'}
                                  name={'skypeId'}
                                  placeholder={formData?.type === 'view' ? '--' : 'Enter Skype ID'}
                                  value={formData?.skypeId}
                                  handleChange={handleChangeForm}
                                  disabled={formData?.type === 'view'}
                                  maxLength={250}
                                  errormsg={errormsg?.skypeId}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6">
                    <div className="infoBox">
                      <div className="addlead-header pd_card">
                        <label htmlFor="" className="flex-div align-items-center">
                          <img className="me-2" src="../assets/images/addressInfo.svg" alt="" />
                          Address Information
                        </label>
                      </div>
                      <div className="leadcontent pd_card leadDetailInfo contactHt2">
                        <>
                          <div className="row">
                            <div className="col-12 col-sm-12 col-md-12">
                              <div className="input-container">
                                <TextBox
                                  label={'Street'}
                                  name={'street'}
                                  placeholder={formData?.type === 'view' ? '--' : 'Enter Street'}
                                  value={formData?.street}
                                  handleChange={handleChangeForm}
                                  disabled={formData?.type === 'view'}
                                  maxLength={250}
                                  errormsg={errormsg?.street}
                                />
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12">
                              <div className="input-container">
                                <TextBox
                                  label={'City'}
                                  name={'city'}
                                  placeholder={formData?.type === 'view' ? '--' : 'Enter City'}
                                  value={formData?.city}
                                  handleChange={handleChangeForm}
                                  disabled={formData?.type === 'view'}
                                  maxLength={250}
                                  errormsg={errormsg?.city}
                                />
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 col-md-12">
                              <div className="input-container">
                                <TextBox
                                  label={'State'}
                                  name={'state'}
                                  placeholder={formData?.type === 'view' ? '--' : 'Enter State'}
                                  value={formData?.state}
                                  handleChange={handleChangeForm}
                                  disabled={formData?.type === 'view'}
                                  maxLength={250}
                                  errormsg={errormsg?.state}
                                />
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12">
                              <div className="input-container">
                                <TextBox
                                  label={'Country'}
                                  name={'country'}
                                  placeholder={formData?.type === 'view' ? '--' : 'Enter Country'}
                                  value={formData?.country}
                                  handleChange={handleChangeForm}
                                  disabled={formData?.type === 'view'}
                                  maxLength={250}
                                  errormsg={errormsg?.country}
                                />
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12">
                              <div className="input-container">
                                <TextBox
                                  label={'Zip Code'}
                                  name={'zipCode'}
                                  placeholder={formData?.type === 'view' ? '--' : 'Enter Zip Code'}
                                  value={formData?.zipCode}
                                  handleChange={handleChangeForm}
                                  disabled={formData?.type === 'view'}
                                  maxLength={250}
                                  errormsg={errormsg?.zipCode}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      </div>{' '}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12">
                <div className="infoBox">
                  <div className="addlead-header pd_card">
                    <label htmlFor="" className="flex-div align-items-center">
                      <img className="me-2" src="../assets/images/notesIcon.svg" alt="" />
                      Notes & Tech Details
                    </label>
                  </div>
                  <div className="leadcontent pd_card leadDetailInfo notesLabel">
                    <>
                      <div className="row">
                        <div className="col-12 col-sm-12 col-md-6">
                          <div className="input-container blockClass">
                            <TextArea
                              label={'Description'}
                              name={'description'}
                              placeholder={formData?.type === 'view' ? '--' : 'Enter Description'}
                              value={formData?.description}
                              handleChange={handleChangeForm}
                              errormsg={errormsg?.description}
                              disabled={formData?.type === 'view'}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-6">
                          <div className="input-container blockClass">
                            <TextArea
                              label={'Technology Stack'}
                              name={'technologyStack'}
                              placeholder={
                                formData?.type === 'view' ? '--' : 'Enter Technology Details'
                              }
                              value={formData?.technologyStack}
                              handleChange={handleChangeForm}
                              errormsg={errormsg?.technologyStack}
                              disabled={formData?.type === 'view'}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </Formik>
  );
};

export default ContactForm;
